import { IDiscountNewBuildings } from '../../types/developer/discounts';

export function getDisplayedNewBuildings(newBuildings: IDiscountNewBuildings[]) {
  if (!newBuildings.length) {
    return null;
  }

  const firstName = newBuildings[0].name;

  return newBuildings.length > 1 ? `${firstName} и еще ${newBuildings.length - 1} ЖК` : firstName;
}
